import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

import type { JSX } from 'react';

export const renderGenerateExcelToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'excel',
      titleFallback: { id: 'pjArtXls02', defaultMessage: 'Excel export' },
    },
    onOpenDocumentExport
  );
